import axios from 'axios';
import authHeader from '@/services/auth.header';
import { HTTP } from '@/http/config'; 
import { AnyObject } from 'yup';
const API_URL = HTTP.api_url;

class PacienteTempService {

    async getIndex():Promise<AnyObject>{    
        const response = await axios.get(API_URL + 'pacientetemps', { headers: authHeader() })
         .then(response => {        
           //console.log(JSON.stringify(response.data.data))
           return response.data;
         }).catch(error => {
           const dataError = JSON.stringify(error.response.data)
           console.log(dataError)      
         });
         return  response;
        }  
    async getSearch(search):Promise<AnyObject>{    
          const response = await axios.get(API_URL + `pacientetemps`, 
          { 
            params: search,
            headers: authHeader() 
          })
           .then(response => {        
             //console.log(JSON.stringify(response.data.data))
             return response.data;
           }).catch(error => {
             const dataError = JSON.stringify(error.response.data)
             console.log(dataError)      
           });
           return  response;
          }  
    async getlist(pageNumber):Promise<AnyObject>{    
        const response = await axios.get(API_URL + `pacientetemps?page=${pageNumber}`, { headers: authHeader() })
         .then(response => {        
           //console.log(JSON.stringify(response.data.data))
           return response.data;
         }).catch(error => {
           const dataError = JSON.stringify(error.response.data)
           console.log(dataError)      
         });
         return  response;
        }      
    async postCreated(pacientes):Promise<AnyObject> {    
         const response = await axios.post(API_URL + 'pacientetemps', 
            pacientes, 
           { headers: authHeader() }
         )
         .then(response =>{
          // console.log(response.data)
           return response.data;
         })
         .catch(error=>{
           const dataError = error.response.data
           console.log(dataError)   
           return dataError;
         });
         return response;
       }
        async postTransfer(pacientes):Promise<AnyObject> {    
         const response = await axios.post(API_URL + 'pacientetemps/store-cita', 
            pacientes, 
           { headers: authHeader() }
         )
         .then(response =>{
          // console.log(response.data)
           return response.data;
         })
         .catch(error=>{
           const dataError = error.response.data
           console.log(dataError)   
           return dataError;
         });
         return response;
       }
       

       async postUpdate(id,pacientes):Promise<AnyObject> {    
          const response = await axios.put(API_URL + `pacientetemps/${id}`,  
            {id:Number(id),...pacientes},     
            { headers: authHeader() },      
          )
          .then(response =>{
            //console.log(response.data)
            return response?.data;
          })
          .catch(error=>{
            const dataError = error.response.data
            console.log(dataError)   
            return dataError;
          });
          return response;
        }
        
       async getEdit(id):Promise<AnyObject[]>{
        const response = await axios.get(API_URL + `pacientetemps/${id}`,     
         { headers: authHeader() }
       )
       .then(response =>{     
         return response?.data;
       })
       .catch(error=>{
         const dataError = error.response.data
         console.log(dataError)   
         return dataError;
       });
       return response;
     }
   
      async getDelete(id):Promise<AnyObject>{
        const response = await axios.delete(API_URL + `pacientetemps/${id}`,     
         { headers: authHeader() }
       )
       .then(response =>{      
         return response?.data;
       })
       .catch(error=>{
         const dataError = error.response.data
         console.log(dataError)   
         return dataError;
       });
       return response;
     }

     async getListPaciente(idPaciente):Promise<AnyObject>{    
      const response = await axios.get(API_URL + `pacientetemps/list-paciente?id=${idPaciente}`, { headers: authHeader() })
       .then(response => {        
         //console.log(JSON.stringify(response.data.data))
         return response.data.data;
       }).catch(error => {
         const dataError = JSON.stringify(error.response.data)
         console.log(dataError)      
       });
       return  response;
      }  
}
export default new PacienteTempService()
